import React, { useMemo } from 'react';

import { FilesList } from '~/components';

import { getDetails } from '~/store/contracts/actions';
import useAsyncActionStatus from '~/hooks/useAsyncActionStatus';
import { FilesContainer } from './Files.styled';

const FILE_NAMES = {
  FACE_FRONT: 'foto-verdade-biometria',
  DOCUMENT_FRONT: 'documento-frente',
  DOCUMENT_BACK: 'documento-verso',
};

export function Files() {
  const detailsControl = useAsyncActionStatus(getDetails);

  const details = detailsControl?.result;
  const id = details?.contract?.externalId;

  const files = useMemo(() => {
    const adhesionTerm = {
      id: 'adhesionTermId',
      imageUrl: details.adhesionTermUrl,
      imageType: 'ADHESION_TERM',
      personImageOrigin: null,
      valid: null,
      name: 'termo-adesao',
      extension: '.pdf',
    };

    const consentTerm = {
      id: 'consentTermId',
      imageUrl: details.consentTermUrl,
      imageType: 'CONSENT_TERM',
      personImageOrigin: null,
      valid: null,
      name: 'termo-consentimento',
      extension: '.pdf',
    };

    let files = [];

    if (details?.formalizationData?.trustworthyPhoto) {
      files.push(details?.formalizationData?.trustworthyPhoto);
    }
    files = files.concat(details?.formalizationData?.checkImagePhotos);
    files = files.concat(details?.formalizationData?.documents);
    files = files.concat(adhesionTerm);
    files = files.concat(consentTerm);

    return (
      files?.map((el) => ({
        name: FILE_NAMES[el?.personImageType],
        url: el?.imageUrl,
        type: el?.personImageType,
        inactive: el?.valid === false,
        ...el,
      })) || []
    );
  }, [details]);

  return (
    <FilesContainer>
      <FilesList id={id} type="CONTRACT" loading={detailsControl.loading} files={files} allowUpload={false} />
    </FilesContainer>
  );
}
